import { State } from "./state.model"

export class Country {
    ID?: number
    COUNTRIES_ID?: number
    COUNTRY_NAME?: string
    COUNTRY_CODE?: string
    CREATED_BY?: string
    CREATED_DATE?: Date
    MODIFIED_BY?: string
    MODIFIED_DATE?: Date

    STATE?: State[]

    MERGED_WITH?: string
    COE_MOVEMENT_INFORMATION?: string[]
    POSTAL_ADDRESSES?: string[]
    PRE_SCREEN_MOVE_INFORMATION?: string[]
    POSTAL_CODES?: string[]
    PROVINCES?: string[]
    STATES?: string[]
    TERRITORIES?: string[]
}
